import { useQuery } from "@tanstack/react-query";
import React, { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { BsArrowLeft } from "react-icons/bs";
import { RiArrowDropDownFill } from "react-icons/ri";
import ClipLoader from "react-spinners/ClipLoader";
import { API } from "../../constants/api";
import useAuthAxios from "../../utils/baseAxios";
import { errorMessage } from "../../utils/errorMessage";
import { formatAmount } from "../../utils/formatTime";

const GiftcardRate = ({ setOpenGiftcardRate }: any) => {
  const [countryName, setCountryName] = useState<string>("");
  const [receipt, setReceipt] = useState<boolean>(false);
  const [cashReceipt, setCashReceipt] = useState<any[]>([]);
  const [actReceipt, setActReceipt] = useState<any[]>([]);
  const [creditReceipt, setCreditReceipt] = useState<any[]>([]);
  const [debitReceipt, setDebitReceipt] = useState<any[]>([]);
  const [cardId, setCardId] = useState<string>("");
  const [cardName, setCardName] = useState<string>("");
  const [cardImg, setCardImg] = useState<string>("");
  const [card, setCard] = useState<any[]>([]);
  const [cardType, setCardType] = useState<string>("physical");
  const [receiptName, setReceiptName] = useState<string>("");

  // const queryClient = useQueryClient();

  const [cardDD, setCardDD] = useState<boolean>(false);
  const [countryDD, setCountryDD] = useState<boolean>(false);
  const axiosInstance = useAuthAxios();
  const getGiftcards = async () => {
    const response = await axiosInstance.get(API.getGiftCards);
    return response.data.data;
  };

  const {
    data: giftcards,
    error: error1,
    isLoading: loading1,
  } = useQuery({
    queryKey: ["get-giftcards"],
    queryFn: getGiftcards,
    retry: 1,
  });

  const getCardDetails = async () => {
    const response = await axiosInstance.get(API.getGiftCardDetails(cardId));
    const rates = response.data.data.giftCard?.rates.filter(
      (rate: any) => rate.isActive && rate.type !== "ecode"
    );
    const groupedData = rates?.reduce((result: any, item: any) => {
      const country = item.country;
      const type = item.type;

      if (!result[country]) {
        result[country] = { country, rates: {} };
      }

      if (!result[country].rates[type]) {
        result[country].rates[type] = [];
      }

      result[country].rates[type].push({
        range: item.range,
        rate: item.rate,
      });

      return result;
    }, {});

    return Object.values(groupedData);
  };
  const {
    data: cardDetails,
    error: error2,
    isLoading: loading2,
    refetch: refetch1,
  } = useQuery({
    queryKey: ["get-card-details"],
    queryFn: getCardDetails,
    enabled: !!cardId, // Prevents the query from running if cardId is not set
    retry: 1,
  });
  const getECardDetails = async () => {
    const response = await axiosInstance.get(API.getGiftCardDetails(cardId));
    const rates = response.data.data.giftCard?.rates.filter(
      (rate: any) => rate.isActive && rate.type === "ecode"
    );
    const groupedData = rates?.reduce((result: any, item: any) => {
      const country = item.country;
      const type = item.type;

      if (!result[country]) {
        result[country] = { country, rates: {} };
      }

      if (!result[country].rates[type]) {
        result[country].rates[type] = [];
      }

      result[country].rates[type].push({
        range: item.range,
        rate: item.rate,
      });

      return result;
    }, {});

    return Object.values(groupedData);
  };
  const {
    data: ecardDetails,
    error: error3,
    isLoading: loading3,
  } = useQuery({
    queryKey: ["get-ecard-details"],
    queryFn: getECardDetails,
    enabled: !!cardId, // Prevents the query from running if cardId is not set
    retry: 1,
  });
  useEffect(() => {
    if (error1) {
      const newError = error1 as any;
      toast.error(errorMessage(newError?.message || newError?.data?.message));
    }
    if (error2) {
      const newError = error2 as any;
      toast.error(errorMessage(newError?.message || newError?.data?.message));
    }
    if (error3) {
      const newError = error3 as any;
      toast.error(errorMessage(newError?.message || newError?.data?.message));
    }
  }, [error1, error2, error3]);
  useEffect(() => {
    if (cardId) {
      refetch1();
    }
  }, [cardId]);

  return (
    <div className="fixed inset-0  flex font-manrope justify-start items-start pt-16 overflow-auto pb-16 bg-[#E7EBEE] dark:bg-primary_dark dark:bg-opacity-95  backdrop-blur-sm">
      <div
        className={` w-11/12 mds:w-8/12 md:7/12 border dark:border-[#303030] bg-white  rounded-xl mx-auto p-6 dark:bg-[#192025]   lgss:w-2/5 xxl:w-1/3 `}
      >
        <div className="w-full flex justify-start gap-6 items-center">
          <button
            onClick={() => {
              setOpenGiftcardRate(false);
            }}
          >
            <BsArrowLeft className="text-black dark:text-white text-[20px]" />
          </button>
          <h4 className="text-gray-900 dark:text-gray-100 font-sora font-semibold text-[20px]">
            See Giftcard Rates
          </h4>
        </div>
        <div className="w-full mt-8">
          <div className="w-full">
            <h4 className="text-[14px] text-gray-800 dark:text-gray-200">
              Card type
            </h4>
            <div className="flex justify-between items-center gap-6 mt-4 w-full">
              <div
                onClick={() => {
                  setCardType("physical");
                  setCardDD(false);
                  setCountryDD(false);
                  if (cardType === "ecode") {
                    setCountryName("");
                  }
                }}
                className={
                  cardType === "physical"
                    ? "border-2 cursor-pointer border-secondary_button h-[72px] flex justify-start px-4 items-center gap-2 rounded-xl text-[13px] text-secondary_button w-1/2"
                    : " h-[72px] cursor-pointer flex justify-start px-4 items-center gap-2 rounded-xl text-[13px] text-gray-800 dark:text-gray-200 w-1/2"
                }
              >
                <div
                  className={`w-[20px] h-[20px] p-1 flex justify-center items-center rounded-full  ${
                    cardType === "physical"
                      ? "border-secondary_button  "
                      : "bg-transparent border-[#505050]"
                  } border `}
                >
                  <div
                    className={`w-full h-full rounded-full  ${
                      cardType === "physical"
                        ? " bg-secondary_button "
                        : "bg-transparent "
                    } `}
                  />
                </div>
                <h4>Physical cards</h4>
              </div>
              <div
                onClick={() => {
                  setCardType("ecode");
                  if (cardType === "physical") {
                    setCountryName("");
                  }
                  setCardDD(false);
                  setCountryDD(false);
                  // queryClient.invalidateQueries({
                  //   queryKey: ["get-card-details"],
                  // });
                }}
                className={
                  cardType === "ecode"
                    ? "border-2 cursor-pointer border-secondary_button h-[72px] flex justify-start px-4 items-center gap-2 rounded-xl text-[13px] text-secondary_button w-1/2"
                    : " h-[72px] cursor-pointer flex justify-start px-4 items-center gap-2 rounded-xl text-[13px] text-gray-800 dark:text-gray-200 w-1/2"
                }
              >
                <div
                  className={`w-[20px] h-[20px] p-1 flex justify-center items-center rounded-full  ${
                    cardType === "ecode"
                      ? "border-secondary_button  "
                      : "bg-transparent border-[#505050]"
                  } border `}
                >
                  <div
                    className={`w-full h-full rounded-full  ${
                      cardType === "ecode"
                        ? " bg-secondary_button "
                        : "bg-transparent "
                    } `}
                  />
                </div>
                <h4>E-code</h4>
              </div>
            </div>
          </div>
          <div className="mt-6 w-full relative">
            <h4 className="text-[14px] text-gray-800 dark:text-gray-200">
              Select Card
            </h4>
            <div
              onClick={() => {
                setCountryDD(false);
                setCardDD((prev) => !prev);
              }}
              className="w-full cursor-pointer border-gray-300 dark:border-gray-600 h-[48px]  rounded-xl mt-2 border px-2 flex justify-between items-center"
            >
              <div className="flex justify-start items-center gap-3">
                {cardImg && (
                  <div className="h-[24px] w-[24px] ">
                    <img
                      src={cardImg}
                      className="h-full w-full bg-cover rounded-full"
                      alt=""
                    />
                  </div>
                )}
                <h4 className="text-[14px] text-gray-700 dark:text-gray-300">
                  {cardName ? cardName : "Select Card"}
                </h4>
              </div>
              <RiArrowDropDownFill className="text-[28px] text-gray-700 dark:text-gray-300" />
            </div>
            {cardDD && (
              <div className="absolute z-50 w-full rounded-xl mt-2 p-3 h-[250px] border border-gray-200 dark:border-gray-600 overflow-auto bg-white dark:bg-gray-800 ">
                {loading1 ? (
                  <div className="w-full pt-8 flex justify-center items-center">
                    <ClipLoader color="#0B84CB" size={40} />
                  </div>
                ) : (
                  <div className="w-full">
                    {giftcards?.giftCards.length >= 1 ? (
                      <div className="w-full">
                        {giftcards?.giftCards.map(
                          (activeCard: any, index: any) => (
                            <button
                              key={index}
                              onClick={() => {
                                setCardId(activeCard._id);
                                setCardImg(activeCard.thumbnail);
                                setCardName(activeCard.name);
                                setCountryName("");
                                setCardDD(false);
                              }}
                              className="py-4 w-full border-b border-gray-200 dark:border-gray-600 flex justify-start items-center gap-3"
                            >
                              <div className="h-[28px] w-[28px] ">
                                <img
                                  src={activeCard.thumbnail}
                                  className="h-full w-full bg-cover rounded-full"
                                  alt=""
                                />
                              </div>
                              {activeCard.name}
                            </button>
                          )
                        )}
                      </div>
                    ) : (
                      <h4 className="text-[14px] lgss:text-[16px] font-bold font-sora text-[#042741] dark:text-white">
                        No card available for trading at the moment.
                      </h4>
                    )}
                  </div>
                )}
              </div>
            )}
          </div>
          <div className="mt-6 w-full relative">
            <h4 className="text-[14px] text-gray-800 dark:text-gray-200">
              Select Country
            </h4>
            <div
              onClick={() => {
                setCardDD(false);
                setCountryDD((prev) => !prev);
              }}
              className="w-full cursor-pointer border-gray-300 dark:border-gray-600 h-[48px]  rounded-xl mt-2 border px-2 flex justify-between items-center"
            >
              <div className="flex justify-start items-center gap-3">
                <h4 className="text-[14px] text-gray-700 dark:text-gray-300">
                  {countryName ? countryName : "Select country"}
                </h4>
              </div>
              <RiArrowDropDownFill className="text-[28px] text-gray-700 dark:text-gray-300" />
            </div>
            {countryDD && cardType === "physical" ? (
              <div className="absolute z-50 rounded-xl w-full mt-2 p-4 h-[250px] overflow-auto bg-white dark:bg-gray-800 ">
                {loading2 ? (
                  <div className="w-full pt-8 flex justify-center items-center">
                    <ClipLoader color="#0B84CB" size={40} />
                  </div>
                ) : (
                  <div className="w-full">
                    {cardDetails && cardDetails?.length >= 1 ? (
                      <div className="w-full">
                        {cardDetails?.map((card: any, index: any) => (
                          <button
                            key={index}
                            onClick={() => {
                              setCountryName(card.country);
                              setCountryDD(false);
                              if (
                                (card.rates?.physicalCashReceipt?.length ??
                                  0) >= 1 ||
                                (card.rates?.physicalActivationReceipt
                                  ?.length ?? 0) >= 1 ||
                                (card.rates?.physicalDebitCardReceipt?.length ??
                                  0) >= 1 ||
                                (card.rates?.physicalCreditCardReceipt
                                  ?.length ?? 0) >= 1
                              ) {
                                setCashReceipt(card.rates?.physicalCashReceipt);
                                setDebitReceipt(
                                  card.rates?.physicalDebitCardReceipt
                                );
                                setActReceipt(
                                  card.rates?.physicalActivationReceipt
                                );
                                setCreditReceipt(
                                  card.rates?.physicalCreditCardReceipt
                                );

                                setReceipt(true);
                              } else {
                                setCard(card.rates?.physicalNoReceipt);
                              }
                            }}
                            className="py-4 w-full border-b border-gray-300 dark:border-gray-600 flex justify-start items-center gap-3"
                          >
                            {card.country}
                          </button>
                        ))}
                      </div>
                    ) : (
                      <h4 className="text-[14px] lgss:text-[16px] font-bold font-sora text-[#042741] dark:text-white">
                        No card available for trading at the moment.
                      </h4>
                    )}
                  </div>
                )}
              </div>
            ) : null}
            {countryDD && cardType === "ecode" ? (
              <div className="absolute z-50 rounded-xl w-full mt-2 p-4 h-[250px] border border-gray-200 dark:border-gray-600 overflow-auto bg-white dark:bg-gray-800 ">
                {loading3 ? (
                  <div className="w-full pt-8 flex justify-center items-center">
                    <ClipLoader color="#0B84CB" size={40} />
                  </div>
                ) : (
                  <div className="w-full">
                    {ecardDetails && ecardDetails?.length >= 1 ? (
                      <div className="w-full">
                        {ecardDetails?.map((card: any, index: any) => (
                          <button
                            key={index}
                            onClick={() => {
                              setCountryName(card.country);
                              setCountryDD(false);
                              setCard(card.rates.ecode);
                            }}
                            className="py-4 w-full border-b border-gray-300 dark:border-gray-600 flex justify-start items-center gap-3"
                          >
                            {card.country}
                          </button>
                        ))}
                      </div>
                    ) : (
                      <h4 className="text-[14px] font-medium font-sora text-[#042741] dark:text-white">
                        No card available for trading at the moment.
                      </h4>
                    )}
                  </div>
                )}
              </div>
            ) : null}
          </div>
          {receipt && (
            <button
              onClick={() => {
                if (cardId) {
                  setReceipt((prev) => !prev);
                }
              }}
              className={`w-full cursor-pointer border-gray-300 dark:border-gray-600 h-[48px]  rounded-xl mt-4 border px-2 flex text-[15px] justify-between items-center text-gray-700 dark:text-gray-300 `}
            >
              {receiptName ? receiptName : "Select receipt type"}
              <RiArrowDropDownFill className="text-[28px] dark:text-[#E8F3FC]" />
            </button>
          )}
          {receipt ? (
            <div
              className={
                "w-full absolute transform transition-transform dark:bg-[#384e5f] duration-300  top-full left-0 mt-2 px-4 shadow-xl rounded-xl  overflow-y-auto bg-[#D4EBFD] scrollbar-thumb-[#60B7F6] p-4 dark:scrollbar-thumb-[#AEBCC6]  "
              }
            >
              {cashReceipt?.length >= 1 && (
                <div
                  onClick={() => {
                    setReceiptName("Cash receipt");
                    setReceipt((prev) => !prev);
                    setCard(cashReceipt);
                  }}
                  className="cursor-pointer"
                >
                  <h4 className="text-[18px] font-bold font-sora  mt-2 text-[#042741] dark:text-white">
                    Cash receipt
                  </h4>
                  <div className="mt-3 w-full h-[2px] bg-gray-300 dark:bg-gray-500" />
                </div>
              )}
              {creditReceipt?.length >= 1 && (
                <div
                  onClick={() => {
                    setReceiptName("Credit card receipt");
                    setReceipt((prev) => !prev);
                    setCard(creditReceipt);
                  }}
                  className="cursor-pointer"
                >
                  <h4 className="text-[18px] font-bold mt-2 font-sora text-[#042741] dark:text-white">
                    Credit card receipt
                  </h4>
                  <div className="mt-3 w-full h-[2px] bg-gray-300 dark:bg-gray-500" />
                </div>
              )}
              {debitReceipt?.length >= 1 && (
                <div
                  onClick={() => {
                    setReceiptName("Debit card receipt");
                    setReceipt((prev) => !prev);
                    setCard(debitReceipt);
                  }}
                  className="cursor-pointer"
                >
                  <h4 className="text-[18px] font-bold font-sora mt-2 text-[#042741] dark:text-white">
                    Debit card receipt
                  </h4>
                  <div className="mt-3 w-full h-[2px] bg-gray-300 dark:bg-gray-500" />
                </div>
              )}
              {actReceipt?.length >= 1 && (
                <div
                  onClick={() => {
                    setReceiptName("Activation receipt");
                    setReceipt((prev) => !prev);
                    setCard(actReceipt);
                  }}
                  className="cursor-pointer"
                >
                  <h4 className="text-[18px] font-bold font-sora mt-2 text-[#042741] dark:text-white">
                    Activation receipt
                  </h4>
                  <div className="mt-3 w-full h-[2px] bg-gray-300 dark:bg-gray-500" />
                </div>
              )}
            </div>
          ) : null}
        </div>
        {card.length >= 1 && (
          <div className="w-full mt-10">
            {cardType === "physical" && (
              <h4 className="mt-2 text-[13px] font-bold font-sora text-secondary_button">
                {receiptName ? receiptName : "No receipt"}
              </h4>
            )}
            {card.map((cd: any, index: number) => (
              <div className="w-full" key={index}>
                <h4 className=" mt-1 text-[13px] font-semibold text-[#13181B] dark:text-gray-100">
                  Range ${cd.range.min} - ${cd.range.max}
                </h4>
                <h4 className=" mt-1 text-[12px] font-bold text-[#BE6B0A]">
                  Rate {formatAmount(cd.rate)} NGN - 1USD
                </h4>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default GiftcardRate;
